import React, { Component, Fragment } from 'react'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import VideoPlayer from '../VideoPlayer'
import Loader from '../Loader'
import VideoSliderControls from '../VideoSliderControls'
import VideoSliderThumb from '../VideoSliderThumb'
import SimpleBtn from '../SimpleBtn'
import { withRouter } from 'react-router-dom'
import { pages } from '../../utils/constants'
import './index.sass'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

class Work extends Component {
  state = {
    activeSlide: 0,
  }

  componentDidMount = () => {
    const {
      work,
      actions: { getWorksList },
    } = this.props

    if (work.length === 0) {
      getWorksList()
    }
  }

  handleChangeNextSlide = () => {
    const { activeSlide } = this.state
    const index = activeSlide + 1
    this.setState({
      activeSlide: index,
    })
  }

  handleChangePrevSlide = () => {
    const { activeSlide } = this.state
    const index = activeSlide - 1
    this.setState({
      activeSlide: index,
    })
  }

  handleChangeSlide = id => {
    const { work } = this.props
    const index = work.findIndex(elem => elem.id === id)
    const { activeSlide } = this.state
    if (activeSlide !== index) {
      this.setState({
        activeSlide: index,
      })
    }
	}
	
	handleBack = () => {
    const { lng, history } = this.props
    const path = lng === 'en' ? `/${pages.WORK}` : `/${lng}/${pages.WORK}`
    history.push(path)
  }

  render = () => {
    const { activeSlide } = this.state
    const {
      work,
      actions: { changeModalVisibility },
      loading,
			t,
			lng,
    } = this.props
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{t('meta.work.title')}</title>
          <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/portfolio/showreels" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/portfolio/showreels" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/portfolio/showreels" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/portfolio/showreels" />
          <meta name="description" content={t('meta.work.descr')} />
          {lng === 'en' && <meta name="keywords" content={t('meta.work.keywords')} />}
          {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/portfolio/showreels'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/portfolio/showreels`} />}
          <meta property="og:title" content={t('meta.work.title')} />
          <meta property="og:description" content={t('meta.work.descr')} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/portfolio/showreels': `https://unimedia.io/${lng}/portfolio/showreels`} />
          <script type="application/ld+json">
          {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('meta.work.descr')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.portfolio')}",
                "item": "https://unimedia.io/portfolio"
              },{
                "@type": "ListItem",
                "position": 3,
                "name": "${t('portfolio.links.showreels')}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'work'} />
        <div className="work-page container" id={'work'}>
          <div className="container-wrapper">
					{/* {lng !=='de' && <button onClick={this.handleBack} className="btn btn-back subtitle-2">
            {t('general.back')}
          </button>} */}
          <Breadcrumbs pathname={window.location.pathname} color='white'/>
            <h3>{t('works.title')}</h3>
            {loading ? (
              <Loader />
            ) : (
              <div className="active-video">
                {work.length > 0 && (
                  <Fragment>
                    <p className="subtitle-1">{t(`works.${activeSlide}.description`)}</p>
                    <VideoSliderControls
                      handleChangePrevSlide={this.handleChangePrevSlide}
                      activeSlide={activeSlide}
                      handleChangeNextSlide={this.handleChangeNextSlide}
                      totalSlides={work.length - 1}
                    />
                    <VideoPlayer
                      videoUrl={work[activeSlide].videoUrl}
                      thumbUrl={work[activeSlide].thumb}
                    />
                    <div className="video-info">
                      <div>
                        <h6>{`${t('general.voice')} ${work[activeSlide].author.replace(
                          /Voice/,
                          ''
                        )}`}</h6>
                        <p className="body-light">{t(`Language.${work[activeSlide].lang}`)}</p>
                      </div>
                      <SimpleBtn
                        btnName={t('general.order voice')}
                        border={true}
                        onHandleClick={() => changeModalVisibility(true)}
                      />
                    </div>
                  </Fragment>
                )}
              </div>
            )}
          </div>
          {work.length > 0 && (
            <div className="video-list">
              {work.map((el, ind) => (
                <VideoSliderThumb
                  key={el.id}
                  thumb={el.thumb}
                  id={el.id}
                  description={t(`works.${ind}.description`)}
                  handleChangeSlide={this.handleChangeSlide}
                  isActive={ind === activeSlide}
                />
              ))}
            </div>
          )}
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  work: state.work,
  loading: state.app.loading,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(Work))
)
